import BaseRepository from "~/api/BaseRepository";

export const InvoiceRepository = (client) => ({
  ...BaseRepository(client)('/invoices'),
  
  sendInvoice: (invoiceId: string, missionId: string, options: { skipGlobalErrorAlert?: boolean } = {}) => {
    return client(`/v2/missions/${missionId}/invoices/${invoiceId}/send`, {
      method: 'POST',
      ...options,
    });
  },
});